<template>
    <v-radio-group
        v-model="localValue"
        :rules="rules"
        color="primary"
        hide-details="auto"
        class="medium-radios"
        density="compact"
    >
        <v-row class="ma-0">
            <v-col
                v-for="(constant, index) in constants.slice(0, 3)"
                :key="'r1-' + index"
                cols="12"
                md="4"
                class="py-2 px-1"
            >
                <v-radio
                    :label="constant.caption"
                    :value="constant.code"
                    density="compact"
                    color="primary"
                    class="medium-radio"
                ></v-radio>
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-col
                v-for="(constant, index) in constants.slice(3, 6)"
                :key="'r2-' + index"
                cols="12"
                md="4"
                class="py-2 px-1"
            >
                <v-radio
                    :label="constant.caption"
                    :value="constant.code"
                    density="compact"
                    color="primary"
                    class="medium-radio"
                ></v-radio>
            </v-col>
        </v-row>
        <v-row class="ma-0">
            <v-col
                v-for="(constant, index) in constants.slice(6, 8)"
                :key="'r3-' + index"
                cols="12"
                md="4"
                class="py-2 px-1"
            >
                <v-radio
                    :label="constant.caption"
                    :value="constant.code"
                    density="compact"
                    color="primary"
                    class="medium-radio"
                ></v-radio>
            </v-col>
        </v-row>
    </v-radio-group>
</template>

<script>

export default {

    props: {
        constants: Array,
        rules: Array,
        value: String
    },

    data() {
        return {
            localValue: this.value
        };
    },

    watch: {
        value(val) {
            this.localValue = val;
        },
        localValue(val) {
            this.$emit('input', val);
            this.$emit('update:modelValue', val);
        },
    },
}

</script>

<style scoped>
.medium-radios {
    font-family: 'Nunito Sans', sans-serif;
}

.medium-radio :deep(.v-selection-control) {
    min-height: 36px !important;
    opacity: 1;
}

.medium-radio :deep(.v-selection-control__wrapper),
.medium-radio :deep(.v-selection-control__input) {
    width: 18px !important;
    height: 18px !important;
}

.medium-radio :deep(.v-selection-control__input > .v-icon) {
    font-size: 18px !important;
    color: #868ebb;
}

.medium-radio :deep(.v-selection-control--dirty .v-selection-control__input > .v-icon) {
    color: #06113a !important;
}

.medium-radio :deep(.v-label) {
    font-family: 'Nunito Sans', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #06113a !important;
    opacity: 1 !important;
    padding-inline-start: 6px;
}

.medium-radio:hover :deep(.v-label) {
    color: #a9343f !important;
}
</style>
